import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import "@common/Login/css/Login.scss";
import { useForm, useWatch } from "react-hook-form";
import { Button, CircularProgress, TextField, Typography } from "@material-ui/core";
import { useTwoWayAuth } from "@features/TwoWayAuth/hook/useTwoWayAuth";

export const TwoWayAuthPage = () => {
    const {
        handleResendOtp,
        resendOtpState,
        handleValidateOtp,
        validateOtpState,
        resendResponse,
        isOtpValid,
    } = useTwoWayAuth();

    const { handleSubmit, errors, register, control } = useForm<{ otp: string }>({
        defaultValues: { otp: "" },
    });

    const { t } = useTranslation(["profile", "common", "validation"]);

    const handleOTPSubmit = handleSubmit(({ otp }) => {
        handleValidateOtp(otp);
    });

    const handleResendOTP = () => {
        handleResendOtp();
    };

    const otp = useWatch<string>({ name: "otp", control: control });
    const isLoading = resendOtpState.isLoading || validateOtpState.isLoading;
    const error = resendOtpState.error || validateOtpState.error;

    return (
        <div className="container-boxed login__container">
            <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                {t("validation:twoFactorAuth")}
            </Typography>
            <Card className="login__card" elevation={2}>
                <CardContent>
                    <Grid alignItems="center" container justify="center" spacing={2}>
                        <Grid item>
                            <div className="login__helper">
                                <Typography align="center" color="secondary" variant="body1">
                                    {t("validation:enterOTP")}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <form onSubmit={handleOTPSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            disabled={isLoading}
                                            error={Boolean(errors.otp)}
                                            fullWidth
                                            helperText={errors.otp?.message}
                                            id={"otp"}
                                            inputRef={register({
                                                required: t("validation:required"),
                                            })}
                                            label={`${t("profile:enterOTP")} *`}
                                            margin="dense"
                                            type="text"
                                            name="otp"
                                        />
                                        {!isOtpValid && (
                                            <Typography color="error">{t("validation:invalidOTP")}</Typography>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container justify="center" direction={"row"} spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    color="secondary"
                                                    fullWidth
                                                    type="submit"
                                                    variant="contained"
                                                    disabled={isLoading || !otp}
                                                >
                                                    {validateOtpState.isLoading ? (
                                                        <CircularProgress size={20} />
                                                    ) : (
                                                        t("profile:verifyOTP")
                                                    )}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    color="secondary"
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={isLoading}
                                                    type="button"
                                                    onClick={async () => {
                                                        handleResendOTP();
                                                    }}
                                                >
                                                    {resendOtpState.isLoading ? (
                                                        <CircularProgress size={20} />
                                                    ) : (
                                                        t("profile:resendOTP")
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {resendResponse.hasError && resendResponse.expires_in && (
                                        <Typography color="error">
                                            {t("validation:otpNotExpired", { expiresIn: resendResponse.expires_in })}
                                        </Typography>
                                    )}
                                    {error && (
                                        <Typography color="error">
                                            {error.errorMessage || t("common:genericError")}
                                        </Typography>
                                    )}
                                </Grid>
                            </form>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
};
